import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './MiniProductSummary.module.scss';
import { Image as FiImage } from '../../../components/Image';
import ValuePropsBox from '../../../views/ProductDetails/Series3CollarDetails/components/ValuePropsBox';
import { ReactComponent as IconDrip } from '../../../assets/images/icons/icon_drip.svg';
import { ReactComponent as IconFeather } from '../../../assets/images/icons/icon_feather.svg';
import { ReactComponent as IconBatteryCharging } from '../../../assets/images/icons/icon_battery_charging.svg';
import { ReactComponent as IconCellular } from '../../../assets/images/icons/icon_cellular.svg';
import { isMobileDevice } from '../../../lib/util/isMobileDevice';
import VerizonLogo from '../../../assets/images/verizon-logo.png';
import { useSeries3Context } from '../../../contexts/Series3Context';
import { FullSpecsSection } from '../../../views/ProductDetails/Series3CollarDetails/components/FullSpecsSection/FullSpecsSection';

export default function MiniProductSummary({ containerRef }: { containerRef?: React.RefObject<HTMLDivElement> }) {
  const { t } = useTranslation();
  const specifications = isMobileDevice() ? t('specs') : t('specifications');
  const { isVerizon } = useSeries3Context();

  return (
    <div ref={containerRef} className={styles.container}>
      <div className={styles.hardwareImage}>
        <FiImage
          image={{
            type: 'image',
            url: '/product_images/mini/unboxing.png',
          }}
        />
        <div className={styles.hardwareImageSubHeading}>{t('includes_fi_mini_device_accessories_and_1_cable')}</div>
      </div>
      <h2 className={styles.heading} style={{ textAlign: 'center' }}>
        {specifications}
      </h2>
      <div className={styles.valueProps}>
        <ValuePropsBox
          className={styles.valuePropsBox}
          columns={1}
          direction="column"
          valueProps={[
            {
              icon: <IconDrip />,
              text: (
                <div className={styles.valueProp}>
                  <div className={styles.valuePropHeader}>{t('fully_waterproof')}</div>
                  <div className={styles.valuePropBody}>{t('ip68_tested_in_salt_water_no_dash')}</div>
                </div>
              ),
            },
            {
              icon: <IconFeather />,
              text: (
                <div className={styles.valueProp}>
                  <div className={styles.valuePropHeader}>{t('small_and_versatile')}</div>
                  <div className={styles.valuePropBody}>{t('can_be_added_to_any_collar')}</div>
                </div>
              ),
            },
            {
              icon: <IconBatteryCharging />,
              text: (
                <div className={styles.valueProp}>
                  <div className={styles.valuePropHeader}>{t('up_to_6_weeks_battery_life')}</div>
                  <div className={styles.valuePropBody}>{t('on_a_single_usb_c_charge')}</div>
                </div>
              ),
            },
            ...(!isVerizon
              ? [
                  {
                    icon: <IconCellular />,
                    text: (
                      <div className={styles.valueProp}>
                        <div className={styles.valuePropHeader}>
                          <img src={VerizonLogo} alt="Verizon" />
                        </div>
                        <div className={styles.valuePropBody}>{t('verizon_lte_m_cellular_network')}</div>
                      </div>
                    ),
                  },
                ]
              : []),
          ]}
        />
      </div>
      <FullSpecsSection isMini />
    </div>
  );
}
